<mat-sidenav-container  (onBackdropClicked)="_onBackdropClicked()">
  @if (isNotLoginPage$ | async) {
    <mat-sidenav [opened]="menuState$ | async" [mode]="'over'"
      (closedStart)="_onClosed()" (openedStart)="_onOpened()"
      class="kn-br-sidebar">
      <cx-page-slot position="TopHeaderSlot"></cx-page-slot>
    </mat-sidenav>
  }
  <mat-sidenav-content>
    <div ng-sidebar-content>
      <kn-br-outlet></kn-br-outlet>
      <cx-storefront [ngClass]="{ 'asm-storefront': isLoggedInASM }"></cx-storefront>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

@if ({spinnerActive:commonService.showSpinner$ | async}; as $) {
  @if ($.spinnerActive) {
    <knbr-cwt-spinner class="cx-dialog-popover-center-backdrop"></knbr-cwt-spinner>
  }
}

<ng-template cxOutletRef="KnBrLandingPage2Template">
  <knbr-landing-page2-template></knbr-landing-page2-template>
</ng-template>
